import { render, staticRenderFns } from "./waste-requests.vue?vue&type=template&id=59d31e20&scoped=true&"
import script from "./waste-requests.vue?vue&type=script&lang=js&"
export * from "./waste-requests.vue?vue&type=script&lang=js&"
import style0 from "./waste-requests.vue?vue&type=style&index=0&id=59d31e20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d31e20",
  null
  
)

export default component.exports